import * as React from 'react';
import { PageProps } from 'gatsby';
import { useTranslation } from 'react-i18next';

type PageContextValue = IPageContext & {};

type IPageContext = {
  lang: string;
  originalPath: string;
};

const PageContext = React.createContext({} as PageContextValue);

export const PageContextProvider = ({
  pageContext,
  children,
}: PageProps<{}, IPageContext>) => {
  const { i18n } = useTranslation();

  // Set the language for i18next from the server side
  if (typeof window === 'undefined') {
    i18n.changeLanguage(pageContext.lang);
  }

  return (
    <PageContext.Provider value={pageContext}>{children}</PageContext.Provider>
  );
};

export const usePageContext = () => React.useContext(PageContext);
